module.exports = __webpack_public_path__ + "img/icon-office.89354ead.svg";